import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { FaturasService } from "../faturas/faturas.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

declare var swal, $: any;

@Component({
  selector: 'app-relatorio-completo',
  templateUrl: './relatorio-completo.component.html'
})
export class RelatorioCompletoComponent extends Components implements OnInit {

  formFiltro: FormGroup;
  filtro = {
    data_de: '',
    data_ate: ''
  };

  clientesData = [];
  totaisGerais = {};
  carregando: boolean = false;
  pesquisado: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    const date = new Date().toISOString();
    this.filtro.data_de = date.substr(0, 8) + '01'; // Primeiro dia do mês corrente
    this.filtro.data_ate = date.substr(0, 10);      // Data de hoje

    this.formFiltro = formBuilder.group({
      data_de: [this.filtro.data_de, [Validators.required]],
      data_ate: [this.filtro.data_ate, [Validators.required]]
    });
  }

  ngOnInit() {
  }

  buscar() {
    if (!this.formFiltro.valid) {
      return;
    }

    this.carregando = true;
    this.pesquisado = true;
    this.clientesData = [];
    this.totaisGerais = {};

    this.faturasService.getRelatorioCompleto(this.filtro.data_de, this.filtro.data_ate)
      .subscribe(
        json => {
          this.clientesData = json.Payload.clientes || [];
          this.totaisGerais = json.Payload.totais_gerais || {};
          this.carregando = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregando = false;
        }
      );
  }

  getMoedas(obj) {
    return Object.keys(obj || {});
  }

  formatDate(dateStr) {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateStr;
  }

  formatCurrency(value, currencyIso) {
    if (value === null || value === undefined) return '';
    const number = Number(value);
    const formatted = number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (currencyIso || 'BRL') === 'USD' ? `US$ ${formatted}` : `R$ ${formatted}`;
  }

  exportToExcel() {
    if (this.clientesData.length === 0) {
      swal(this.func.traduzir('front.erro'), "Nenhum dado encontrado para exportação.", "error");
      return;
    }

    let html = `
      <table border="1">
        <thead>
          <tr style="background-color: #f2f2f2; font-weight: bold;">
            <th>Tipo</th>
            <th>Serviço</th>
            <th>Container</th>
            <th>Conhecimento/BL</th>
            <th>Fatura</th>
            <th>Status</th>
            <th>Data</th>
            <th>Data Status</th>
            <th>Nota Fiscal</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
    `;

    for (let client of this.clientesData) {
      // Client Header row spanning all columns
      html += `
        <tr style="background-color: #1F4E78; color: #FFFFFF; font-weight: bold;">
          <td colspan="10" style="font-size: 14px; padding: 6px;">${client.cliente_nome}</td>
        </tr>
      `;

      for (let item of client.itens) {
        html += `
          <tr>
            <td>${item.tipo || ''}</td>
            <td>${item.servico || ''}</td>
            <td>${item.container || ''}</td>
            <td>${item.bl || ''}</td>
            <td>${item.fatura || ''}</td>
            <td>${item.status || ''}</td>
            <td>${this.formatDate(item.data)}</td>
            <td>${this.formatDate(item.data_status)}</td>
            <td>${item.nota_fiscal || ''}</td>
            <td style="text-align: right;">${this.formatCurrency(item.valor, item.moeda)}</td>
          </tr>
        `;
      }

      // Client total invoices row
      let totalClientStr = this.getMoedas(client.totais_por_moeda)
        .map(m => this.formatCurrency(client.totais_por_moeda[m], m))
        .join(' / ');

      html += `
        <tr style="background-color: #DDEBF7; font-weight: bold;">
          <td colspan="9" style="text-align: right; padding: 5px;">Total Faturas - ${client.cliente_nome}:</td>
          <td style="text-align: right; padding: 5px; color: #1F4E78;">${totalClientStr}</td>
        </tr>
        <tr><td colspan="10" style="border: none; height: 10px;"></td></tr>
      `;
    }

    // Grand totals row at the end
    let totalGeralStr = this.getMoedas(this.totaisGerais)
      .map(m => this.formatCurrency(this.totaisGerais[m], m))
      .join(' / ');

    html += `
      <tr style="background-color: #BDD7EE; font-weight: bold; font-size: 13px;">
        <td colspan="9" style="text-align: right; padding: 6px;">VALOR TOTAL GERAL (TODOS OS CLIENTES):</td>
        <td style="text-align: right; padding: 6px; color: #1F4E78;">${totalGeralStr}</td>
      </tr>
    `;

    html += '</tbody></table>';

    const header = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:Workbook><x:Worksheets><x:Worksheet><x:Name>Relatorio Completo</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:Worksheet></x:Worksheets></x:Workbook></xml><![endif]--></head><body>`;
    const footer = `</body></html>`;

    const blob = new Blob([header + html + footer], { type: 'application/vnd.ms-excel;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Relatorio_Completo_${this.filtro.data_de}_a_${this.filtro.data_ate}.xls`;
    a.click();
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/relatorio-completo.component.ts